(function () {
  'use strict';

  const popup = document.querySelector('[data-newsletter-popup]');
  if (!popup) return;

  const STORAGE_KEY = 'newsletter_popup_closed_until';
  const POPUP_FORM_ID = 'newsletter_popup_form';
  const EXCLUDED_PATHS = ['/pages/iscrizione-newsletter-qb24', '/cart', '/account', '/checkout'];
  const ACTIVITY_EVENTS = ['mousemove', 'pointerdown', 'keydown', 'scroll', 'touchstart'];
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])';

  const delayMs = (parseInt(popup.dataset.delay, 10) || 5) * 1000;
  const frequencyDays = parseInt(popup.dataset.frequency, 10) || 7;

  let timer = null;
  let previousFocus = null;

  if (window.location.search.includes('reset_newsletter_popup')) {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* storage non disponibile */ }
  }

  function isExcludedPath() {
    const path = window.location.pathname;
    return EXCLUDED_PATHS.some((p) => path.includes(p));
  }

  function isClosed() {
    try {
      const until = localStorage.getItem(STORAGE_KEY);
      return !!until && new Date(until) > new Date();
    } catch (e) {
      return false;
    }
  }

  function remember() {
    try {
      const until = new Date(Date.now() + frequencyDays * 24 * 60 * 60 * 1000);
      localStorage.setItem(STORAGE_KEY, until.toISOString());
    } catch (e) { /* storage non disponibile */ }
  }

  function postedFormId() {
    if (window.NewsletterForm && typeof window.NewsletterForm.postedFormId === 'function') {
      return window.NewsletterForm.postedFormId();
    }
    const params = new URLSearchParams(window.location.search);
    return params.get('customer_posted') === 'true' ? window.location.hash.replace(/^#/, '') : null;
  }

  function hasServerError() {
    if (window.location.hash !== '#' + POPUP_FORM_ID) return false;
    const msg = popup.querySelector('[data-form-msg]');
    return !!msg && msg.textContent.trim().length > 0;
  }

  function isOpen() {
    return !popup.hasAttribute('hidden');
  }

  function focusables() {
    return Array.from(popup.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
  }

  function focusInitial() {
    const dialog = popup.querySelector('[role="dialog"]');
    const title = popup.querySelector('[data-step]:not([hidden]) .newsletter__title');
    if (dialog && title) dialog.setAttribute('aria-label', title.textContent.trim());
    const target = popup.querySelector('[data-step]:not([hidden]) input[type="email"]') || popup.querySelector('[data-newsletter-popup-focus]');
    if (target) target.focus();
  }

  function open() {
    if (isOpen()) return;
    previousFocus = document.activeElement;
    popup.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    Promise.race([
      customElements.whenDefined('newsletter-form'),
      new Promise((resolve) => setTimeout(resolve, 1000))
    ]).then(() => setTimeout(focusInitial, 50));
    popup.dispatchEvent(new CustomEvent('newsletter-popup:open'));
  }

  function close() {
    if (!isOpen()) return;
    popup.setAttribute('hidden', '');
    document.body.style.overflow = '';
    remember();
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    popup.dispatchEvent(new CustomEvent('newsletter-popup:close'));
  }

  function onKeydown(event) {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;
    if (!popup.contains(active)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function disarm() {
    clearTimeout(timer);
    ACTIVITY_EVENTS.forEach((name) => document.removeEventListener(name, onActivity, true));
  }

  function fire() {
    disarm();
    if (isClosed()) return;
    open();
  }

  function onActivity() {
    clearTimeout(timer);
    timer = setTimeout(fire, delayMs);
  }

  function arm() {
    if (isClosed() || isExcludedPath()) return;
    ACTIVITY_EVENTS.forEach((name) => document.addEventListener(name, onActivity, { capture: true, passive: true }));
    timer = setTimeout(fire, delayMs);
  }

  function init() {
    popup.querySelectorAll('[data-newsletter-popup-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', onKeydown);
    document.querySelectorAll('newsletter-form').forEach((el) => el.addEventListener('form:submit', remember));

    const posted = postedFormId();
    if (posted === POPUP_FORM_ID || hasServerError()) {
      open();
      return;
    }
    if (posted !== null) {
      remember();
      return;
    }
    arm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
